import { IMAGES } from "../lib/site";
import { FadeUp, MaskedLine } from "./Reveal";

const MOODS = [
    {
        n: "I",
        tag: "Mood I",
        name: "Noir Heritage",
        desc: "Panelled walls, aged brass, lantern light \u2014 bathrooms with character.",
        img: IMAGES.heritage,
    },
    {
        n: "II",
        tag: "Mood II",
        name: "Burgundy Heritage",
        desc: "Glossy burgundy tiles, brass sconces, fluted oak \u2014 warmth in every detail.",
        img: IMAGES.burgundy,
    },
    {
        n: "III",
        tag: "Mood III",
        name: "Emerald Calm",
        desc: "Green marble, black fittings, warm cove light \u2014 spa evenings at home.",
        img: IMAGES.emerald,
    },
    {
        n: "IV",
        tag: "Mood IV",
        name: "Modern Terrazzo",
        desc: "Fluted glass, warm wood, playful terrazzo \u2014 compact homes, done bold.",
        img: IMAGES.terrazzo,
    },
    {
        n: "V",
        tag: "Mood V",
        name: "Emerald Herringbone",
        desc: "Herringbone tiles, lit niches, warm candlelight \u2014 slow spa rituals.",
        img: IMAGES.herringbone,
    },
    {
        n: "VI",
        tag: "Detail",
        name: "Fittings, chosen by hand",
        desc: "Every tap, shower and fixture picked for feel, finish and finish quality.",
        img: IMAGES.fittings,
    },
];

const Styles = () => (
    <section className="relative bg-noir text-white overflow-hidden" data-testid="styles-section">
        <div className="spotlight" />
        <div className="relative mx-auto max-w-[1440px] px-5 sm:px-10 py-16 sm:py-24">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between mb-14 sm:mb-20">
                <div>
                    <FadeUp>
                        <p className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-brass mb-6">
                            The new Indian bathroom
                        </p>
                    </FadeUp>
                    <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.2rem,4.5vw,4rem)]">
                        <MaskedLine>Many moods.</MaskedLine>
                        <MaskedLine delay={0.1}>
                            <em className="italic text-brass">One</em> standard.
                        </MaskedLine>
                    </h2>
                </div>
                <FadeUp delay={0.2}>
                    <p className="max-w-sm text-sm sm:text-base font-light leading-relaxed text-white/60">
                        From heritage drama to quiet minimalism &mdash; every Bath & Beyond renovation is
                        styled around how you want your mornings to feel.
                    </p>
                    <p className="mt-4 font-mono text-[10px] tracking-[0.3em] uppercase text-brass/80">
                        A Spaces by Samita venture
                    </p>
                </FadeUp>
            </div>

            <div className="grid gap-5 sm:gap-8 sm:grid-cols-3 max-w-6xl mx-auto">
                {MOODS.map((m, i) => (
                    <FadeUp key={m.name} delay={i * 0.1}>
                        <figure
                            className="group relative overflow-hidden rounded-[1.5rem] sm:rounded-[2rem] shadow-[0_20px_60px_rgba(0,0,0,0.35)]"
                            data-testid={`style-mood-${i + 1}`}
                        >
                            <div className="aspect-[3/4]">
                                <img
                                    src={m.img}
                                    alt={m.name}
                                    loading="lazy"
                                    className="h-full w-full object-cover img-treated transition-transform duration-[1.2s] ease-out group-hover:scale-[1.04]"
                                />
                            </div>
                            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-noir/90 via-noir/40 to-transparent p-5 sm:p-7">
                                <p className="font-mono text-[9px] sm:text-[10px] tracking-[0.3em] text-brass uppercase mb-1.5">
                                    {m.tag}
                                </p>
                                <h3 className="font-serif text-xl sm:text-2xl">{m.name}</h3>
                                <p className="mt-1.5 text-[11px] sm:text-xs font-light text-white/65">
                                    {m.desc}
                                </p>
                            </figcaption>
                        </figure>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);

export default Styles;
